import { MenuItem } from '../../../../vendors/@types/menu';
import {
  faArrowRightToBracket,
  faBell,
  faCircleQuestion,
  faEnvelope,
  faHome,
} from '@fortawesome/free-solid-svg-icons';

export const publicMenuItems: MenuItem[] = [
  {
    label: 'Login',
    icon: faArrowRightToBracket,
    url: '/login/unico',
    id: 'login',
  },
  {
    label: 'Página inicial',
    icon: faHome,
    url: '/public',
    id: 'public-home',
  },
  {
    separator: true,
    id: 'public-sep-comunicados',
  },
  {
    label: 'Comunicados e Alertas',
    icon: faBell,
    url: '/informes',
    id: 'public-informes',
    badgeSource: 'informes',
  },
  {
    label: 'Dúvidas frequentes',
    icon: faCircleQuestion,
    url: '/duvidas-frequentes',
    id: 'public-duvidas-frequentes',
  },
  {
    label: 'Fale conosco',
    icon: faEnvelope,
    url: '/fale-conosco/inicio',
    id: 'public-fale-conosco',
  },
];
